export default {
  upTo30: 0,
  upTo60: 1,
  upTo90: 2,
  above90: 3,
  all: 4,
};
